import { render, staticRenderFns } from "./ShowProgram.vue?vue&type=template&id=09bba0e6&scoped=true&"
import script from "./ShowProgram.vue?vue&type=script&lang=js&"
export * from "./ShowProgram.vue?vue&type=script&lang=js&"
import style0 from "../../components/common/css/NewsCP.css?vue&type=style&index=0&id=09bba0e6&scoped=true&lang=css&"
import style1 from "./ShowProgram.vue?vue&type=style&index=1&id=09bba0e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bba0e6",
  null
  
)

export default component.exports